// Sign-in and Register tours - storefront /account/login and /account/register.
// Purely explanatory: no step asks the customer to type into a credential field.
import { path, exists, visible } from './util.js';

export var signIn = {
  id: 'sign-in',
  version: 1,
  title: 'Signing in',
  icon: 'user',
  duration: '20 sec',
  available: function () { return path() === '/account/login' && exists('#sign-in-form'); },
  readySelector: '#sign-in-form form[action="/account/login"]',
  inviteDelay: 1800,
  invite: {
    kicker: 'Your account',
    title: 'What a Goldwagen account gets you',
    body: 'A quick look at signing in, and what it unlocks: My Garage, order history, quotes and returns.',
  },
  steps: [
    {
      title: 'Your Goldwagen account',
      body: 'Signing in unlocks <b>My Garage</b>, your order history, quotes and returns, and checkout with your saved details.',
      icon: 'user',
      hero: 'intro',
    },
    {
      target: '#Email',
      icon: 'mail',
      title: 'Your email address',
      body: 'Use the email address you registered with. It is also how we find your orders.',
      padding: 6,
    },
    {
      target: '#Password',
      icon: 'lock',
      title: 'Your password',
      body: 'Passwords are case-sensitive. Check Caps Lock if it does not work.',
      padding: 6,
    },
    {
      target: function () { var c = document.getElementById('RememberMe'); return c ? (c.closest('label, .checkbox, .form-check, .form-group') || c) : null; },
      icon: 'check',
      title: 'Stay signed in',
      body: 'On your own device, tick this to skip signing in next time. Leave it unticked on a shared computer.',
      optional: true,
      padding: 6,
    },
    {
      target: 'a.lnk-forgot-password',
      icon: 'key',
      title: 'Forgotten it?',
      body: 'We will email you a secure link to set a new password.',
      optional: true,
    },
    {
      target: function () { return visible('#sign-in-form button[type="submit"]') || visible('#sign-in-form button.g-recaptcha') || visible('#sign-in-form form button.btn:not(.entra-btn)'); },
      icon: 'login',
      title: 'Sign in',
      body: 'You will come straight back to where you were, with your store and vehicle remembered.',
    },
    {
      target: function () { return visible('.form-centered-header a[href="/account/register"]') || visible('a[href="/account/register"]'); },
      icon: 'userplus',
      title: 'New to Goldwagen?',
      body: 'Creating an account is free and takes about a minute.',
      nextLabel: 'Got it',
      optional: true,
    },
  ],
};

export var register = {
  id: 'register',
  version: 1,
  title: 'Creating an account',
  icon: 'user',
  duration: '25 sec',
  available: function () { return path() === '/account/register' && exists('form[action="/account/register"]'); },
  readySelector: 'form[action="/account/register"]',
  inviteDelay: 1800,
  invite: {
    kicker: 'Create an account',
    title: 'Set up your account in a minute',
    body: 'A quick walk-through of the form, and what you get once you’re in.',
  },
  steps: [
    {
      title: 'Create your Goldwagen account',
      body: 'Free, and it only takes a minute. Once you’re in you can save vehicles to <b>My Garage</b>, track orders and log returns.',
      icon: 'userplus',
      hero: 'intro',
    },
    {
      target: function () { return visible('.form-register-details ul.nav-pills'); },
      icon: 'list',
      title: 'Individual or workshop?',
      body: 'Choose <b>Individuals</b> for personal use, or <b>Workshop</b> if you buy for a workshop or fleet.',
      optional: true,
      waitFor: 1200,
    },
    {
      target: function () { return visible('#Individual_Email') || visible('form[action="/account/register"] input[type="email"]'); },
      icon: 'mail',
      title: 'Your email',
      body: 'This is your sign-in, and where order confirmations are sent.',
      padding: 6,
    },
    {
      target: function () {
        var f = visible('#Individual_FirstName');
        var l = visible('#Individual_LastName');
        if (!f) return null;
        // Spotlight both name fields when they share a row.
        // Spotlight both name fields only when they sit in their own row wrapper;
        // on this form every group shares the <form>, so fall back to first name.
        var a = f.closest('.form-group') || f, b = l && (l.closest('.form-group') || l);
        if (b && a.parentElement === b.parentElement && a.parentElement.children.length <= 3) return a.parentElement;
        return a;
      },
      icon: 'user',
      title: 'Your name',
      body: 'Your first and last name, as you would like them on invoices and collection slips.',
      optional: true,
      padding: 6,
    },
    {
      target: function () { return visible('#Individual_Mobile') || visible('#Individual_MobileNumber') || visible('form[action="/account/register"] input[type="tel"]'); },
      icon: 'phone',
      title: 'Mobile number',
      body: 'We only use it for updates on your orders, collections and deliveries.',
      optional: true,
      padding: 6,
    },
    {
      target: function () { return visible('#Individual_Password') || visible('form[action="/account/register"] input[type="password"]'); },
      icon: 'lock',
      title: 'Choose a password',
      body: 'Pick something strong that you don’t use anywhere else, then confirm it below.',
      padding: 6,
    },
    {
      // The register button is reCAPTCHA-driven (button.g-recaptcha, no type=submit).
      target: function () { return visible('#individuals button.g-recaptcha') || visible('#individuals button[type="submit"]') || visible('form[action="/account/register"] button.btn'); },
      icon: 'check',
      title: 'Create account',
      body: 'That’s it. You’ll be signed in straight away.',
      nextLabel: 'Got it',
    },
  ],
};
